/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ApprovalRequestApprovalType } from './approvalRequestApprovalType';
import type { ApprovalRequestChangelog } from './approvalRequestChangelog';
import type { ApprovalRequestVersionsToReplace } from './approvalRequestVersionsToReplace';
import type { ApprovalRequestHeadline } from './approvalRequestHeadline';
import type { ApprovalRequestImpactNotice } from './approvalRequestImpactNotice';
import type { ApprovalRequestOfferToVersions } from './approvalRequestOfferToVersions';

export interface ApprovalRequest {
  approvalType?: ApprovalRequestApprovalType;
  changelog?: ApprovalRequestChangelog;
  versionsToReplace?: ApprovalRequestVersionsToReplace;
  headline?: ApprovalRequestHeadline;
  impactNotice?: ApprovalRequestImpactNotice;
  invalidatesProgress?: boolean;
  offerToVersions?: ApprovalRequestOfferToVersions;
}
